if (!customElements.get('planted-sticky-bar')) {
  class PlantedStickyBar extends HTMLElement {
    connectedCallback() {
      const el = this.children[0]
      const stickyClasses = this.getAttribute('data-sticky-class')?.split(' ')
      let curScroll
      function updatePosition() {
        curScroll = window.scrollY || document.scrollTop
        const { top } = this.getBoundingClientRect()
        const { height } = el.getBoundingClientRect()

        const isSmallScreen = window.matchMedia('(max-width: 767px)').matches
        if (isSmallScreen && top + height <= window.innerHeight) {
          el.style.position = 'fixed'
          el.style.bottom = '0'
          el.style.left = '0'
          el.style.right = '0'
          stickyClasses.forEach((cls) => {
            el.classList.add(cls)
          })
        } else {
          el.style.position = 'static'
          stickyClasses.forEach((cls) => {
            el.classList.remove(cls)
          })
        }
      }
      window.addEventListener('scroll', updatePosition.bind(this))
      window.addEventListener('resize', updatePosition.bind(this))
    }
  }
  customElements.define('planted-sticky-bar', PlantedStickyBar)
}
